import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { BOOKING_SLOTS } from "./labels";

// Riprogrammazione appuntamento: scelta nuova data lavorativa + slot libero (agenda condivisa
// con la prenotazione pubblica, stessa validazione del backend).
export default function RescheduleControl({ booking, onDone, onCancel }) {
  const [date, setDate] = useState(booking.date || "");
  const [time, setTime] = useState("");
  const [taken, setTaken] = useState([]);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [busy, setBusy] = useState(false);

  const minDate = new Date(Date.now() + 86400000).toISOString().slice(0, 10);

  useEffect(() => {
    if (!date) return;
    let cancelled = false;
    setLoadingSlots(true);
    api
      .get("/bookings/availability", { params: { date } })
      .then(({ data }) => {
        if (!cancelled) setTaken(data.taken || []);
      })
      .catch(() => {
        if (!cancelled) setTaken([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingSlots(false);
      });
    return () => {
      cancelled = true;
    };
  }, [date]);

  const confirm = async () => {
    if (!date || !time) {
      toast.error("Scegli data e orario della nuova sessione");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.patch(`/bookings/${booking.id}`, { date, time, status: "confermata" });
      toast.success("Appuntamento riprogrammato");
      onDone(data);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-3 border border-[#c9a45c]/25 bg-[#161616] p-4" data-testid={`reschedule-control-${booking.id}`}>
      <p className="text-[9px] font-bold uppercase tracking-[0.16em] text-gold-light">Riprogramma sessione</p>
      <div className="mt-3 flex flex-wrap items-end gap-3">
        <label className="text-[11px] text-[#c9c6bf]">
          <span className="mb-1 block text-[9px] uppercase tracking-[0.14em] text-[#a8a5a0]">Nuova data (lavorativa)</span>
          <input
            type="date"
            min={minDate}
            value={date}
            onChange={(e) => {
              setDate(e.target.value);
              setTime("");
            }}
            className="field !w-auto !py-2 !text-[12px]"
            data-testid={`reschedule-date-${booking.id}`}
          />
        </label>
        {date && (
          <label className="text-[11px] text-[#c9c6bf]">
            <span className="mb-1 block text-[9px] uppercase tracking-[0.14em] text-[#a8a5a0]">
              Orario {loadingSlots ? "…" : ""}
            </span>
            <select
              value={time}
              onChange={(e) => setTime(e.target.value)}
              className="field !w-auto !py-2 !text-[12px]"
              data-testid={`reschedule-time-${booking.id}`}
            >
              <option value="">Scegli orario</option>
              {BOOKING_SLOTS.map((s) => (
                <option key={s} value={s} disabled={taken.includes(s)}>
                  {s} {taken.includes(s) ? "· occupato" : ""}
                </option>
              ))}
            </select>
          </label>
        )}
        <button
          onClick={confirm}
          disabled={busy || !date || !time}
          className="btn btn-gold !min-h-[36px] !px-4 !text-[10px] disabled:opacity-50"
          data-testid={`reschedule-confirm-${booking.id}`}
        >
          {busy ? <Loader2 size={12} className="animate-spin" /> : null} Conferma nuova data
        </button>
        <button
          onClick={onCancel}
          className="btn btn-outline !min-h-[36px] !px-4 !text-[10px]"
          data-testid={`reschedule-cancel-${booking.id}`}
        >
          Annulla
        </button>
      </div>
    </div>
  );
}
